export enum MultipleOptionsMessageType {
  NONE = 'NONE', //default type when no message is displayed
  ADMIT_USER = 'ADMIT_USER', //type used to validate if there is a single user in the waiting room
  MULTIPLE_ADMIT_USER = 'MULTIPLE_ADMIT_USER',
}

export interface SettingsMultipleOptionsMessage {
  text: string;
  color: string;
}
